import React, { useEffect } from "react";
import { isBrowserContext } from "../../../util/ContextHelper";

const handleObserve: IntersectionObserverCallback = (entries, observer) =>
{
    entries.forEach(function (entry)
    {
        if (entry.isIntersecting)
        {
            const animateElement = entry.target as HTMLImageElement;
            if (animateElement && animateElement.dataset?.animate)
            {
                animateElement.classList.add(animateElement.dataset?.animate);
                observer.unobserve(animateElement);
            }
        }
    });
};

interface AnimateProps
{
    effectClassName?: string;
}

const options: IntersectionObserverInit = {
    threshold: 0.5
};

const animateObserver = isBrowserContext() ? new IntersectionObserver(handleObserve, options) : null;

const Animate: React.FC<AnimateProps> = (props) =>
{
    const { effectClassName, ...rest } = props;
    const animateRef = React.createRef<HTMLElement>();

    useEffect(() =>
    {
        if (animateObserver)
        {
            if (typeof animateRef === "function")
            {
                // How to handle functions?
            }
            else if (animateRef?.current)
            {
                animateObserver.observe(animateRef.current);
            }

            return () =>
            {
                if (typeof animateRef === "function")
                {
                    // How to handle functions?
                }
                else if (animateRef?.current)
                {
                    animateObserver.unobserve(animateRef.current);
                }
            };
        }
    }, [effectClassName, animateRef]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return React.cloneElement(props.children as React.DetailedReactHTMLElement<any, HTMLElement>, {
        ref: animateRef,
        ...rest,
        "data-animate": effectClassName
    });
};

export default Animate;